import { database as db } from 'firebase';

export default {
    updatePageOffset({ state, getters }, offset) {
        state.pageOffset = offset;
    },
    lockProject({ getters }, value) {
        try {
            const projectRef = db().ref(getters.projectPath);
            projectRef.child('locked').set(value);
        } catch (e) {
            console.error(e);
        }
    },
    deleteProject({ getters }, projectID) {
        try {
            const projectRef = db().ref(`/projects/${projectID}`);
            projectRef.remove();
        } catch (e) {
            console.error(e);
        }
    },
    // COLLABORATOR FUNCTIONS
    addPendingCollaborator({ getters }, { project, collaborator, inviter }) {
        const projectRef = db().ref(`/projects/${project.id}`);
        const pendingCollabsRef = projectRef.child('pendingCollaborators');
        const newPendingCollab = pendingCollabsRef.push();
        collaborator.id = newPendingCollab.key;

        if (inviter) {
            collaborator.inviter = inviter;
        }

        newPendingCollab.set(collaborator);
    },
    removePendingCollaborator({ getters }, { project, pendingCollaboratorID }) {
        try {
            const projectRef = db().ref(`/projects/${project.id}`);
            projectRef.child(`pendingCollaborators/${pendingCollaboratorID}`).remove();
        } catch (e) {
            console.error(e);
        }
    },
    addCollaborator({ getters }, { project, uid, pendingCollaborator }) {
        try {
            const projectRef = db().ref(`/projects/${project.id}`);
            const collabsRef = projectRef.child('collaborators');
            const pendingCollabsRef = projectRef.child('pendingCollaborators');

            const collab = {uid: uid, layers: {}, role: pendingCollaborator.role};

            if (project.layers) {
                Object.keys(project.layers).forEach((layer) => {
                    collab.layers[layer] = false;
                });
            }
            
            collabsRef.child(`${collab.uid}`).set(collab).then(() => {
                pendingCollabsRef.child(pendingCollaborator.id).remove();
            });
        } catch (e) {
            console.error(e);
        }
    },
    updateCollaborator({ getters }, collaborator) {
        const projectRef = db().ref(`/projects/${getters.project.id}`);
        const collabRef = projectRef.child(`collaborators/${collaborator.uid}`);
        collabRef.update(collaborator);
    },
    removeCollaborator({ getters }, { project, collaboratorID }) {
        const projectRef = db().ref(`/projects/${project.id}`);
        const collabRef = projectRef.child(`collaborators/${collaboratorID}`);
        collabRef.remove();
    },

    // NOTE FUNCTIONS
    addUserNote({ getters }, { note, layer }) {
        try {
            const projectRef = db().ref(getters.projectPath);
            const newNoteRef = projectRef.child('notes').push();

            newNoteRef.set({
                id: newNoteRef.key,
                x: note.x,
                y: note.y,
                width: 100,
                height: 40,
                page: note.pageNumber,
                layer: layer.id,
                text: ''
            });
        } catch (e) {
            console.error(e);
        }
    },
    updateUserNote({ getters }, { note }) {
        try {
            const projectRef = db().ref(getters.projectPath);
            const noteRef = projectRef.child(`notes/${note.id}`);

            noteRef.update({
                x: note.x,
                y: note.y,
                text: note.text,
                width: note.width,
                height: note.height,
                layer: note.layer
            });
        } catch (e) {
            console.error(e);
        }
    },
    removeUserNote({ getters }, { note }) {
        try {
            const projectRef = db().ref(getters.projectPath);
            const noteRef = projectRef.child(`notes/${note.id}`);
            noteRef.remove();
        } catch (e) {
            console.error(e);
        }
    },

    // LAYER FUNCTIONS
    addLayer({ getters }, layer) {
        try {
            const projectRef = db().ref(getters.projectPath);
            const newLayerRef = projectRef.child('layers').push();

            layer.id = newLayerRef.key;
            newLayerRef.set(layer);
        } catch (e) {
            console.error(e);
        }
    },
    updateLayer({ getters }, layer) {
        try {
            const projectRef = db().ref(getters.projectPath);
            const layerRef = projectRef.child(`layers/${layer.id}`);
            layerRef.update({
                color: layer.color,
                colorDetails: layer.colorDetails,
                title: layer.title
            });
        } catch (e) {
            console.error(e);
        }
    },
    removeLayer({ getters }, layer) {
        try {
            const projectRef = db().ref(getters.projectPath);
            const cues = getters.cues;

            const layerCues = cues.filter((cue) => {
                return cue.layer === layer.id;
            });

            for (let i = layerCues.length - 1; i >= 0; i--) {
                const cue = layerCues[i];
                const cueRef = projectRef.child(`cues/${cue.id}`);
                cueRef.remove();
            }

            const layerRef = projectRef.child(`layers/${layer.id}`);
            layerRef.remove();
        } catch (e) {
            console.error(e);
        }
    },
    setEditingLayer({ getters }, layer) {
        try {
            const userLayersRef = db().ref(`/users/${getters.user.uid}/projects/${getters.project.id}/layers`);
            userLayersRef.child('editing').set(layer.id);
        } catch (e) {
            console.log('printing error');
            console.error(e);
        }
    },
    showLayer({ getters }, layer) {
        try {
            const layers = getters.visibleLayerIDs;
            const index = layers.findIndex(elem => elem === layer.id);
            if (index === -1) {
                layers.unshift(layer.id);
                const userLayersRef = db().ref(`/users/${getters.user.uid}/projects/${getters.project.id}/layers`);
                userLayersRef.child('viewing').set(layers);
            }
        } catch (e) {
            console.error(e);
        }
    },
    showAllLayers({ getters }) {
        try {
            const layers = getters.visibleLayerIDs;
            const userLayersRef = db().ref(`/users/${getters.user.uid}/projects/${getters.project.id}/layers`);
            userLayersRef.child('viewing').set(layers);
        } catch (e) {
            console.error(e);
        }
    },
    showAllProjectLayers({ getters }, { project, layers }) {
        try {
            const layerIDs = layers.map(layer => layer.id);
            const userLayersRef = db().ref(`/users/${getters.user.uid}/projects/${project.id}/layers`);
            userLayersRef.child('viewing').set(layerIDs);
        } catch (e) {
            console.error(e);
        }
    },
    hideLayer({ getters }, layer) {
        try {
            const layers = getters.visibleLayerIDs;
            const index = layers.findIndex(elem => elem === layer.id);
            if (index > -1) {
                layers.splice(index, 1);
            }
            const userLayersRef = db().ref(`/users/${getters.user.uid}/projects/${getters.project.id}/layers`);
            userLayersRef.child('viewing').set(layers);
        } catch (e) {
            console.error(e);
        }
    },
    hideAllLayers({ getters }) {
        try {
            const userLayersRef = db().ref(`/users/${getters.user.uid}/projects/${getters.project.id}/layers`);
            userLayersRef.child('viewing').remove();
        } catch (e) {
            console.error(e);
        }
    },
    hideAllProjectLayers({ getters }, project) {
        try {
            const userLayersRef = db().ref(`/users/${getters.user.uid}/projects/${project.id}/layers`);
            userLayersRef.child('viewing').remove();
        } catch (e) {
            console.error(e);
        }
    },
    showNotes({ getters }, layer) {
        try {
            const layers = getters.showNotesLayers;
            const index = layers.findIndex(elem => elem === layer.id);
            if (index === -1) {
                layers.unshift(layer.id);
                const userLayersRef = db().ref(`/users/${getters.user.uid}/projects/${getters.project.id}/layers`);
                userLayersRef.child('showNotes').set(layers);
            }
        } catch (e) {
            console.error(e);
        }
    },
    hideNotes({ getters }, layer) {
        try {
            const layers = getters.showNotesLayers;
            const index = layers.findIndex(elem => elem === layer.id);
            if (index > -1) {
                layers.splice(index, 1);
            }
            const userLayersRef = db().ref(`/users/${getters.user.uid}/projects/${getters.project.id}/layers`);
            userLayersRef.child('showNotes').set(layers);
        } catch (e) {
            console.error(e);
        }
    },

    // CUE FUNCTIONS
    addCue({ getters }, cue) {
        try {
            const projectRef = db().ref(getters.projectPath);
            const newCueRef = projectRef.child('cues').push();
            cue.id = newCueRef.key;
            cue.layer = getters.currentLayer.id;
            newCueRef.set(cue);
        } catch (e) {
            console.error(e);
        }
    },
    deleteCue({ getters }, cue) {
        try {
            const projectRef = db().ref(getters.projectPath);
            projectRef.child(`cues/${cue.id}`).remove();
        } catch (e) {
            console.error(e);
        }
    },
    updateCue({ getters }, cue) {
        try {
            const projectRef = db().ref(getters.projectPath);
            projectRef.child(`cues/${cue.id}`).update({
                x: cue.x,
                y: cue.y,
                description: cue.description,
                width: cue.width,
                height: cue.height,
                pageNumber: cue.pageNumber,
                title: cue.title,
                layer: cue.layer
            });
        } catch (e) {
            console.error(e);
        }
    },

    useVersion({ state, getters }, versionID) {
        console.log(`using version ${versionID}`);
        state.activeVersion = versionID;
    },
    createVersion({ getters }, versionName) {
        try {
            const project = getters.project;
            const userUID = getters.user['.key'];
            const now = new Date();
            const newVersionRef = db().ref(`/projects/${project.id}/versions`).push();

            const cues = project.cues || [];
            const layers = project.layers || [];
            const notes = project.notes || [];

            newVersionRef.set({
                id: newVersionRef.key,
                created: now.toISOString(),
                name: versionName,
                cues: cues,
                layers: layers,
                notes: notes,
                creator: userUID
            });
        } catch (e) {
            console.error(e);
        }
    },
    deleteVersion({ state, getters }, versionID) {
        try {
            if (state.activeVersion === versionID) state.activeVersion = null;
            const versionRef = db().ref(`/projects/${getters.project.id}/versions/${versionID}`);
            versionRef.remove();
        } catch (e) {
            console.error(e);
        }
    },
    promoteVersion({ state, getters }, versionID) {
        try {
            const project = getters.project;
            const userUID = getters.user['.key'];
            // const now = new Date();
            const version = getters.versionByID(versionID);

            if (userUID === getters.ownerUID) {
                const projectRef = db().ref(`/projects/${project.id}`);
                const cues = version.cues || [];
                const layers = version.layers || [];
                const notes = version.notes || [];

                projectRef.update({
                    cues: cues,
                    layers: layers,
                    notes: notes
                });
            }
        } catch (e) {
            console.error(e);
        }
    },
    updateUser({ state, getters }, {uid, update}) {
        try {
            console.log(uid);
            console.log(update);
            const userRef = db().ref(`/users/${uid}`);

            userRef.update(update);
        } catch (e) {
            console.error(e);
        }
    },
    updateShowMode({ state, getters }, showModeValue) {
        state.showMode = showModeValue;
    }
};


// WEBPACK FOOTER //
// ./sample/lib/vuex/actions.js